import { render, staticRenderFns } from "./ReportBase.vue?vue&type=template&id=b8999726"
import script from "./ReportBase.vue?vue&type=script&lang=js"
export * from "./ReportBase.vue?vue&type=script&lang=js"
import style0 from "./ReportBase.vue?vue&type=style&index=0&id=b8999726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports